import { Box, Typography } from "@mui/material";
import { projectsRecord } from "./project";
import SingleProj from "./SingleProj";

import "./project.css";
import "boxicons";

export default function Projects() {
  const isMobile = window.innerWidth <= 768; 

  return (
    <section id="projects">
      <Typography variant="h4" className="project-title" id={!isMobile ? "fromTop" : ""}>
        Featured
      </Typography>
      <Box className="project-main">
        {projectsRecord.map((item, index) => (
          <SingleProj
            key={index}
            imgSrc={item.imgSrc}
            projectName={item.projectName}
            url={item.url}
            description={item.description}
            id={`${
              index == 0 || index == 1 || index == 4 || index == 5
                ? !isMobile ? "fromLeft" : ""
                : !isMobile ? "fromRight" : ""
            }`}
          />
        ))}
      </Box>
    </section>
  );
}
